import { useTranslation } from '@packlink/translation-provider';
import { Spinner, Typography } from '@shipengine/giger';
import { useBrandedEmailsSettings } from '@common/hooks/useBrandedEmailsSettings';
import { EmailTemplateListItem } from './components/EmailTemplateListItem/EmailTemplateListItem';
import { emailTypesKeys } from './constants';
import { EmailTemplateDisabledItem } from './components/EmailTemplateListItem/EmailTemplateDisabledItem';
import { getDisabledSectionStyles, getListContainerStyles, getSpinnerStyles } from './EmailTemplatesListStyles';

export interface EmailTemplatesListProps {
    onEdit: () => void;
    onToggle?: (active: boolean) => void;
    subscribed: boolean;
}

export function EmailTemplatesList({ onEdit, onToggle, subscribed }: EmailTemplatesListProps): JSX.Element {
    const { t } = useTranslation();

    const { brandedEmails, isLoading, isRefetching } = useBrandedEmailsSettings(subscribed);

    const editEmail = () => {
        brandedEmails && onEdit();
    };

    return (
        <section>
            {subscribed ? (
                <>
                    <Typography component="p" variant="body2">
                        {t('branded-emails.template-list.customise-description')}
                    </Typography>

                    <section css={getListContainerStyles}>
                        {isLoading || isRefetching ? (
                            <Spinner css={getSpinnerStyles} />
                        ) : (
                            !isLoading &&
                            !isRefetching &&
                            brandedEmails &&
                            brandedEmails?.emails.map((template) => (
                                <EmailTemplateListItem
                                    key={template.emailType}
                                    template={template}
                                    onEdit={editEmail}
                                    onToggle={onToggle}
                                />
                            ))
                        )}
                    </section>
                </>
            ) : (
                <section css={getDisabledSectionStyles}>
                    <EmailTemplateDisabledItem templateKey={emailTypesKeys.BRANDED_SHIPMENT_CONFIRMATION} />
                </section>
            )}
        </section>
    );
}
